export default __webpack_public_path__ + "static/media/Savvy.eec6fad1.png";